import globalMethods from "@/globalMethods";
import {URLS, RESPONSES} from "@/constants";
import {notify} from "@/plugins/notification";
import i18n from "@/i18n";


export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async payPlan(_, params) {
            const {amountShops, name, promoCodeId} = params;
            const url = URLS.PAY.CREATE_PAYMENT_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                },
                credentials: "include",
                body: JSON.stringify({
                    amount_shops: amountShops,
                    name: name,
                    promo_code: promoCodeId,
                }),
            };
            const successfulHandler = async (data) => {
                notify(i18n.global.t("Redirecting to the payment page..."), 3000);
                if (window.Capacitor?.isNativePlatform?.()) {
                    const {Browser} = await import('@capacitor/browser');
                    await Browser.open({url: data.data});
                } else {
                    window.location.href = data.data;
                }
                return {successfully: true};
            };
            const errorHandler = (data) => {
                if (data.detail === RESPONSES.NOT_FOUND) {
                    notify(i18n.global.t("The entered promo code is not valid. Please try a different one"), "red");
                    return {successfully: false};
                }
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler, errorHandler: errorHandler});
        },
        async goToFreePlan({commit}) {
            const url = URLS.PAY.GO_TO_FREE_PLAN_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                },
                credentials: "include",
            };
            const successfulHandler = (data) => {
                commit("company/setCompanyData", data.data, {root: true});
                notify(i18n.global.t("You have been successfully switched to the free plan"))
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    },
};